import { ChatStatus } from '@rematter/frontend-lib-api-client/grpc/assistant/v1/assistant_pb';
import { ChatUpdatedEvent } from '@rematter/frontend-lib-api-client/grpc/assistant/v1/events_pb';
import { Col, DiffViewer, FieldDisplay, IDField } from '@rematter/ui-web';

import { useTranslations } from '../../../i18n/useTranslations';

type ChatUpdatedDetailProps = {
  event: ChatUpdatedEvent;
};

//
// ⚛️ ⚛️ ⚛️ CHAT UPDATED DETAIL ⚛️ ⚛️ ⚛️
//
export const ChatUpdatedDetail = ({ event }: ChatUpdatedDetailProps) => {
  const t = useTranslations();

  const previous = event.previousChat;
  const current = event.updatedChat;

  const chatStatusLabels: Record<ChatStatus, string> = {
    [ChatStatus.UNSPECIFIED]: t.logs.chatStatus.unspecified,
    [ChatStatus.ACTIVE]: t.logs.chatStatus.active,
    [ChatStatus.ARCHIVED]: t.logs.chatStatus.archived,
  };

  if (!previous || !current) {
    return (
      <Col className="@ChatUpdatedDetail items-center justify-center p-4 text-neutral/40">
        <span>{t.logs.noDataAvailable}</span>
      </Col>
    );
  }

  const diffs = [
    {
      field: 'title',
      label: t.logs.fields.title,
      previous: previous.title,
      current: current.title,
    },
    {
      field: 'status',
      label: t.logs.fields.status,
      previous: chatStatusLabels[previous.status],
      current: chatStatusLabels[current.status],
    },
    {
      field: 'agentId',
      label: t.logs.fields.agentId,
      previous: previous.agentId?.value,
      current: current.agentId?.value,
    },
  ];

  return (
    <Col className="@ChatUpdatedDetail gap-3" gap3>
      <Col className="rounded-md border border-neutral/10 bg-white p-3" gap2>
        <span className="text-xs font-medium text-neutral/60">
          {t.logs.chat}
        </span>
        <div className="grid grid-cols-2 gap-x-4 gap-y-1">
          <IDField label={t.logs.fields.id} value={current.id?.value} />
          <FieldDisplay label={t.logs.fields.title} value={current.title} />
        </div>
      </Col>

      <Col className="rounded-md border border-neutral/10 bg-white p-3" gap1>
        <span className="mb-2 text-xs font-medium text-neutral/60">
          {t.logs.changes}
        </span>
        <DiffViewer
          diffs={diffs}
          previousLabel={t.logs.before}
          currentLabel={t.logs.after}
        />
      </Col>
    </Col>
  );
};
